import { useEffect, useRef } from "react";
import { useLexicalComposerContext } from "@lexical/react/LexicalComposerContext";
import { registerReviewText } from ".";

interface ReviewTextPluginProps {
  isEnabled?: boolean;
}

export function ReviewTextPlugin({ isEnabled = true }: ReviewTextPluginProps) {
  const [editor] = useLexicalComposerContext();
  const isEnabledRef = useRef(isEnabled);
  
  // Update the ref when isEnabled changes
  useEffect(() => {
    isEnabledRef.current = isEnabled;
  }, [isEnabled]);
  
  // Register commands only once
  useEffect(() => {
    const cleanup = registerReviewText(editor, isEnabledRef);
    return cleanup;
  }, [editor]);

  return null;
}
